import React from "react";
import { useTranslation } from "react-i18next";

// Styles
import styles from "./practice.module.css";

// Assets
import ReviewIcon from "./assets/review.png";
import PuzzleIcon from "./assets/puzzle.png";
import GradCapIcon from "./assets/gradcap.png";

// Utils
import { courseMistakesUrl } from "../../../utils/urls";

const Practice = ({ courseId }) => {
  // Hooks
  const { t } = useTranslation();

  // Handlers
  const handleReview = () => {
    Turbo.visit(courseMistakesUrl(courseId));
  }
  const handleQuickTest = () => {
  }
  const handleFullTest = () => {
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttonsContainer}>
        <button className={`${styles.button} bg-gray-200`} onClick={handleReview}>
          <img src={ReviewIcon} alt="review" className={styles.icon} />

          <p className='text-sm text-black'>
            {t('studyPathSideBar.practice.review')}
          </p>
        </button>

        <button className={`${styles.button} bg-gray-200`} onClick={handleQuickTest}>
          <img src={PuzzleIcon} alt="quick test" className={styles.icon} />

          <p className='text-sm text-black'>
            {t('studyPathSideBar.practice.quick_test')}
          </p>
        </button>
      </div>
      <div className={styles.buttonsContainer}>
        <button className={`${styles.button} bg-gray-200`} onClick={handleFullTest}>
          <img src={GradCapIcon} alt="full test" className={styles.icon} />

          <p className='text-sm text-black'>
            {t('studyPathSideBar.practice.full_test')}
          </p>
        </button>
      </div>
    </div>
  )
}

export default Practice;
